import React from "react";

import Footer from "./footer";
import Testimonials from "./Testimonial";
import WhatsAppScrollButton from "./floatingwhatsApp";
import CircularScrollProgress from "./Circularprogress";
import AboutCounter from "./aboutcounter";



function Aboutcompany() {
    return (

        // aboutcompany
        <>

            <div className="hero-area10 header-background about-hero">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="title title2  ">
                                <div className="headding-shape aniamtion-key-2">
                                    <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                                </div>
                                <h1 className="sk-text-color">What is Dm2Legal?</h1>

                                <p className="pd-text">Meet the expert online legal advisors at Dm2Legal—your go-to platform for professional legal assistance across all areas of law. Our team specializes in simplifying even the most complex legal processes, making legal solutions accessible and stress-free for everyone.<br/><br/>

From legal consultations to document preparation and expert guidance, Dm2Legal offers a comprehensive suite of services tailored to your needs. Whether you're dealing with contracts, claims, disputes, or any legal concerns, we’re here to provide clarity and support every step of the way.

<br/><br/>Get expert legal solutions at your fingertips—connect with Dm2Legal today!</p>
                                <div className="space20"></div>
                                <p className="pd-text"></p>
                                <div className="space20"></div>
                                {/* <div className="couter-all ">
                                    <div className="row">
                                        <div className="col-sm-4 col-md-4 col-4">
                                            <div className="counter10-counter-box counter-line">
                                                <h2 className="black-color"><span className="counter">90</span>k</h2>
                                                <p className="black-color">Happy Client</p>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 col-md-4 col-4">
                                            <div className="counter10-counter-box counter-line">
                                                <h2 className="black-color"><span className="counter">650</span>+</h2>
                                                <p className="black-color">Solved Case</p>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 col-md-4 col-4">
                                            <div className="counter10-counter-box dis ">
                                                <h2 className="black-color"><span className="counter">85</span>+</h2>
                                                <p className="black-color">Work Together</p>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <img src="assets/img/images/About-TDS-Return-Filing.png" alt="" />

                        </div>
                    </div>
                </div>
            </div>
            <div className="space40"></div>


            <div className="service-binifits9 sp0" >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="space10"></div>
                            <img src="assets/img/images/partnership-deed-image.jpg" alt="" />
                        </div>
                        <div className="col-lg-8">
                            <div className="hadding7">
                                <div className="space20"></div>
                                <p className="pd-text">Unsure about how to respond to or draft a Legal Notice? We’ve got you covered. Get in touch with our legal experts and resolve all your Legal Notice-related concerns quickly and efficiently.</p>
                                <div className="space20"></div>
                                <p className="pd-text">A legal notice is a written communication between two parties regarding a grievance. In this notice, the sender, as the aggrieved party, informs the recipient of their intent to take legal action. It also serves as a final warning, giving the recipient an opportunity to fulfill a specific condition to avoid court proceedings, thereby allowing the recipient to resolve the issue appropriately.</p>
                                <div className="space20"></div>
                                <p className="pd-text">A legal notice can be drafted independently, but it requires a solid understanding of legal terminology, conditions, and language. The same applies to the recipient. Once a legal notice is prepared or responded to, it cannot be altered, and if the matter goes to court, it will be considered as is. Therefore, it is advisable to seek legal advice before drafting or responding to a legal notice. Contact our legal experts for the best guidance.</p>

                            </div>
                        </div>

                    </div>

                </div>
            </div>

            <div className="space40"></div>

            <AboutCounter />
            <div className="space20"></div>


            <Testimonials />
            <div className="space40"></div>




            <WhatsAppScrollButton />

            <Footer />

            <CircularScrollProgress />


        </>
    );
}

export default Aboutcompany;